import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formControlShouldShowValidation',
  pure: false
})
export class FormControlShouldShowValidationPipe implements PipeTransform {
  transform(control: any): boolean {
    //This is *any* because in some cases it's an NGControl and in some cases it's an AbstractControl
    //And it seems to go crazy if I try and do conversions etc
    if (!control) {
      return false;
    }
    return control.invalid && (control.dirty || control.touched);
  }
}

/**
 * Allows you to say the following on an div with a warning message
 * *ngIf="manageForm.controls['lastDateforEntry'] | formControlShouldShowValidationForError: 'date-min'"
 */
@Pipe({
  name: 'formControlShouldShowValidationForError',
  pure: false
})
export class FormControlShouldShowValidationForError implements PipeTransform {
  transform(control: any, error: string): boolean {
    // control needs to be normalized because if input is type NGControl, it has a control property,
    // and if it is type AbstractControl, it is a control in itself
    const activeControl = control?.control ?? control;

    if (!activeControl) {
      return false;
    }

    const hasErr = activeControl.hasError?.(error) ?? !!activeControl.errors?.[error];

    if (!hasErr) {
      return false;
    }

    if (error === 'required' && Object.keys(activeControl.errors ?? {}).length > 1) {
      return false;
    }

    return activeControl.invalid && (activeControl.dirty || activeControl.touched);
  }
}

@Pipe({
  name: 'formControlShouldShowWarning',
  pure: false
})
export class FormControlShouldShowWarning implements PipeTransform {
  transform(control: any, error?: string): boolean {
    //This is *any* because in some cases it's an NGControl and in some cases it's an AbstractControl
    //And it seems to go crazy if I try and do conversions etc
    if (!control) {
      return false;
    }

    if (!control.warnings || (error && !control.warnings[error])) {
      return false;
    }

    return !control.errors && (control.dirty || control.touched);
  }
}
